'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class;

var _components = require('components');

var _auth = require('redux/modules/auth');

var _reactDatetime = require('react-datetime');

var _reactDatetime2 = _interopRequireDefault(_reactDatetime);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRouter = require('react-router');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _translations = require('translations');

var _translations2 = _interopRequireDefault(_translations);

var _reduxConnect = require('redux-connect');

var _reactRedux = require('react-redux');

var _account = require('redux/modules/account');

var _messages = require('redux/modules/messages');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reachHistory = require('../../helpers/reachHistory');

var _MessageTemplateReport = require('./MessageTemplateReport.scss');

var _MessageTemplateReport2 = _interopRequireDefault(_MessageTemplateReport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var md = {
  arrowBack: require('react-icons/lib/md/arrow-back'),
  share: require('react-icons/lib/md/call-made')
};

var MessageTemplateReport = (_dec = (0, _reduxConnect.asyncConnect)([{
  key: 'account',
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var state = getState();
    if (!state.account.data.reach) {
      return dispatch((0, _account.getAccount)());
    }
    return null;
  }
}, {
  key: "auth",
  promise: function promise(_ref2) {
    var _ref2$store = _ref2.store,
        dispatch = _ref2$store.dispatch,
        getState = _ref2$store.getState;

    if (!(0, _auth.isLoaded)(getState())) {
      return dispatch((0, _auth.load)());
    }
    return null;
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    account: state.auth.current_account,
    user: state.auth.data.user
  };
}, { getAccount: _account.getAccount, pushState: _reachHistory.push, getTemplateReport: _messages.getTemplateReport }), _dec(_class = _dec2(_class = function (_React$Component) {
  (0, _inherits3.default)(MessageTemplateReport, _React$Component);

  function MessageTemplateReport(props) {
    (0, _classCallCheck3.default)(this, MessageTemplateReport);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MessageTemplateReport.__proto__ || (0, _getPrototypeOf2.default)(MessageTemplateReport)).call(this, props));

    _this.state = {
      template_uid: null,
      from: (0, _moment2.default)().startOf('month').valueOf(),
      to: (0, _moment2.default)().endOf('month').valueOf(),
      template_report: null,
      name: null,
      created_by: null,
      created_on: null,
      content: null,
      variables: [null]

    };

    return _this;
  }

  (0, _createClass3.default)(MessageTemplateReport, [{
    key: 'componentDidMount',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var from, to, template_id, name, created_by, created_on, content, variables, reports;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                from = this.state.from;
                to = this.state.to;
                template_id = this.props.location.state.templateInformation._id;
                name = this.props.location.state.templateInformation.name;
                created_by = this.props.location.state.templateInformation.created_by;
                created_on = this.props.location.state.templateInformation.created_on;
                content = this.props.location.state.templateInformation.properties.content;
                variables = this.props.location.state.templateInformation.properties.variables;
                _context.next = 11;
                return this.props.getTemplateReport(template_id, from, to);

              case 11:
                reports = _context.sent;


                this.setState({
                  template_report: reports,
                  template_uid: template_id,
                  name: name,
                  created_on: (0, _moment2.default)(created_on).format('DD/MM/YYYY'),
                  created_by: created_by,
                  content: content,
                  variables: variables
                });

                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](0);


                console.log('no template data');
                this.props.pushState({
                  pathname: '/fail',
                  state: {
                    goTo: '/messages/templates',
                    message: 'no template data',
                    goToModal: false,
                    returnTo: '/messages/templates'
                  }
                });

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 15]]);
      }));

      function componentDidMount() {
        return _ref3.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'fromDateChange',
    value: function fromDateChange(date) {
      if (date < this.state.to) {
        var newDate = (0, _moment2.default)(date).valueOf();
        this.setState({ from: newDate });
      }
    }
  }, {
    key: 'toDateChange',
    value: function toDateChange(date) {
      if (date > this.state.from) {
        var newDate = (0, _moment2.default)(date).valueOf();
        this.setState({ to: newDate });
      }
    }
  }, {
    key: 'search',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var template_uid, from, to, reports;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                template_uid = this.state.template_uid;
                from = this.state.from;
                to = this.state.to;

                this.setState({ template_report: null });
                _context2.next = 6;
                return this.props.getTemplateReport(template_uid, from, to);

              case 6:
                reports = _context2.sent;

                this.setState({ template_report: reports });

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function search() {
        return _ref4.apply(this, arguments);
      }

      return search;
    }()
  }, {
    key: 'renderStadistics',
    value: function renderStadistics() {

      if (this.state.template_report != null) {
        var info = this.state.template_report;
        return _react2.default.createElement(
          'div',
          { className: _MessageTemplateReport2.default.chart },
          _react2.default.createElement(_components.ReportChart, { config: {

              series: [{
                name: (0, _translations2.default)('SENT MESSAGES'),
                pointInterval: 24 * 3600 * 1000,
                pointStart: info.result[0].key,
                data: info.result.map(function (value) {
                  return value['messages_sent'];
                }),
                legendIndex: 1
              }, {
                name: (0, _translations2.default)('ERROR MESSAGES'),
                pointInterval: 24 * 3600 * 1000,
                pointStart: info.result[0].key,
                data: info.result.map(function (value) {
                  return value['errors'];
                }),
                color: '#FF0000',
                legendIndex: 3
              }, {
                name: (0, _translations2.default)('CONFIRMED MESSAGES'),
                pointInterval: 24 * 3600 * 1000,
                pointStart: info.result[0].key,
                data: info.result.map(function (value) {
                  return value['messages_confirmed'];
                }),
                legendIndex: 2
              }]
            } })
        );
      };
    }
  }, {
    key: 'renderTable',
    value: function renderTable() {
      var number_width = 200;

      var columns = [{
        Header: (0, _translations2.default)('DATE'),
        accessor: 'key_as_string',
        width: number_width,
        Cell: function Cell(props) {
          return _react2.default.createElement(
            'span',
            null,
            (0, _moment2.default)(props.value).format('DD/MM/YYYY')
          );
        }
      }, {
        Header: (0, _translations2.default)('SENT MESSAGES'),
        accessor: 'messages_sent',
        width: '1f'
      }, {
        Header: (0, _translations2.default)('CONFIRMED MESSAGES'),
        accessor: 'messages_confirmed',
        width: '1f'
      }, {
        Header: (0, _translations2.default)('ERROR MESSAGES'),
        accessor: 'errors',
        width: '1f'
      }];

      if (this.state.template_report != null) {
        return _react2.default.createElement(
          'div',
          { className: _MessageTemplateReport2.default.table },
          _react2.default.createElement(_components.Table, {
            data: this.state.template_report.result,
            columns: columns,
            isLoading: false
          })
        );
      }
    }
  }, {
    key: 'renderVariables',
    value: function renderVariables() {
      var variables = this.state.variables;
      if (variables != null) {
        return variables.map(function (variable) {
          return _react2.default.createElement(
            'li',
            null,
            variable
          );
        });
      }
    }
  }, {
    key: 'renderTemplateInfo',
    value: function renderTemplateInfo() {
      var content = this.state.content;
      var created_by = this.state.created_by;
      var created_on = this.state.created_on;
      var id = this.state.template_uid;

      return _react2.default.createElement(
        'div',
        { className: _MessageTemplateReport2.default.infoBody },
        _react2.default.createElement(
          'div',
          { className: _MessageTemplateReport2.default.templateContent },
          _react2.default.createElement(
            'div',
            { className: _MessageTemplateReport2.default.message },
            _react2.default.createElement(
              'div',
              { className: _MessageTemplateReport2.default.title },
              (0, _translations2.default)('MESSAGE CONTENT')
            ),
            _react2.default.createElement(
              'div',
              { className: _MessageTemplateReport2.default.content },
              content
            )
          ),
          _react2.default.createElement(
            'div',
            { className: _MessageTemplateReport2.default.variables },
            _react2.default.createElement(
              'div',
              { className: _MessageTemplateReport2.default.title },
              (0, _translations2.default)('AVAILABLE VARIABLES')
            ),
            _react2.default.createElement(
              'ul',
              { className: _MessageTemplateReport2.default.variableList },
              this.renderVariables()
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _MessageTemplateReport2.default.author },
          (0, _translations2.default)('CREATED BY'),
          ': ',
          created_by,
          ' ',
          ' ',
          ' ',
          (0, _translations2.default)('ON'),
          ' ',
          created_on,
          _react2.default.createElement(
            'div',
            { className: _MessageTemplateReport2.default.ID },
            'ID: ',
            id
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var name = this.state.name;
      var templateInfo = {
        _id: this.state.template_uid,
        name: this.state.name
      };
      return _react2.default.createElement(
        'div',
        { className: _MessageTemplateReport2.default.main },
        _react2.default.createElement(_reactHelmet2.default, { title: (0, _translations2.default)("TEMPLATE REPORT") }),
        _react2.default.createElement(
          'div',
          { className: _MessageTemplateReport2.default.header },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/messages/templates' },
            _react2.default.createElement(md.arrowBack, { size: 20, color: '#FFF', className: _MessageTemplateReport2.default.back })
          ),
          _react2.default.createElement(
            'div',
            { className: _MessageTemplateReport2.default.name },
            name
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: { pathname: '/messages/templates/share',
                state: { templateInformation: templateInfo } }, className: _MessageTemplateReport2.default.linkshare },
            _react2.default.createElement(
              'button',
              { className: _MessageTemplateReport2.default.share },
              (0, _translations2.default)('SHARE')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _MessageTemplateReport2.default.body },
          this.renderTemplateInfo(),
          _react2.default.createElement(
            'div',
            { className: _MessageTemplateReport2.default.reportDate },
            (0, _translations2.default)('REPORT DATE')
          ),
          _react2.default.createElement(
            'div',
            { className: _MessageTemplateReport2.default.datepickerContainer },
            _react2.default.createElement(
              'div',
              { className: _MessageTemplateReport2.default.datepicker },
              _react2.default.createElement(
                'div',
                null,
                (0, _translations2.default)('FROM')
              ),
              _react2.default.createElement(
                'div',
                { className: _MessageTemplateReport2.default.date },
                _react2.default.createElement(_reactDatetime2.default, { value: this.state.from, onChange: this.fromDateChange.bind(this) })
              ),
              _react2.default.createElement(
                'div',
                null,
                (0, _translations2.default)('TO')
              ),
              _react2.default.createElement(
                'div',
                { className: _MessageTemplateReport2.default.date },
                _react2.default.createElement(_reactDatetime2.default, { value: this.state.to, onChange: this.toDateChange.bind(this) })
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_components.Button, { name: 'Buscar', className: _MessageTemplateReport2.default.button, onClick: function onClick() {
                    return _this2.search();
                  } })
              )
            )
          ),
          this.renderStadistics(),
          this.renderTable()
        )
      );
    }
  }]);
  return MessageTemplateReport;
}(_react2.default.Component)) || _class) || _class);
exports.default = MessageTemplateReport;
module.exports = exports['default'];